import { render, staticRenderFns } from "./UpdateAnnouncementPage.vue?vue&type=template&id=dcad56ce&scoped=true"
import script from "./UpdateAnnouncementPage.vue?vue&type=script&lang=js"
export * from "./UpdateAnnouncementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcad56ce",
  null
  
)

export default component.exports